import React, { createContext, useContext } from 'react';
import { useContainerWidth } from '../hooks/useContainerWidth';

const ResponsiveLayoutContext = createContext({
    isCompact: false,
    containerWidth: 0,
});

export function useResponsiveLayout() {
    return useContext(ResponsiveLayoutContext);
}

/**
 * Provider for responsive layout context
 * Wraps the main content area and provides compact mode state to children
 */
export function ResponsiveLayoutProvider({ children, threshold = 600, style = {} }) {
    const { containerRef, isCompact, containerWidth } = useContainerWidth(threshold);

    return (
        <ResponsiveLayoutContext.Provider value={{ isCompact, containerWidth }}>
            <div
                ref={containerRef}
                className="responsive-layout-container chat-main-content"
                data-compact={isCompact}
                style={{
                    containerType: 'inline-size',
                    display: 'flex',
                    flexDirection: 'column',
                    height: '100%',
                    overflow: 'hidden',
                    position: 'relative',
                    minWidth: 0,
                    flexShrink: 1, // Changed from 0 to allow shrinking
                    transition: 'width 0.3s cubic-bezier(0.4, 0, 0.2, 1), max-width 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                    ...style, // Allow parent to override width
                }}
            >
                {children}
            </div>
        </ResponsiveLayoutContext.Provider>
    );
}
